import { Card } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ProfileTabs from "../components/ProfileTabs";
import LoadingIcon from "../components/LoadingIcon";

const Profile = () => {
  const token = localStorage.getItem("token");
  const [loadingState, setLoadingState] = useState(false);
  const [user, setUser] = useState({});
  const [plan, setPlan] = useState("");

  const getDetails = useCallback(async () => {
    setLoadingState(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}customerDetails`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    const data = await response.json();
    console.log(data.User.fullName);
    

    setUser(data.User);

    switch (data.User.plan) {
      case "1":
        setPlan("Startup");
        break;
      case "2":
        setPlan("Standard");
        break;
      case "3":
        setPlan("Premium");
        break;
      case "4":
        setPlan("Silver");
        break;
      case "5":
        setPlan("Gold");
        break;

      default:
        break;
    }
    setLoadingState(false);
  }, [token]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  return (
    <>
      {loadingState ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <div className="min-h-screen">
          <div className="mb-9">
            <h3 className="font-bold text-2xl text-white">Profile</h3>
          </div>
          <div className="md:flex block mt-10">
            <div className="md:w-1/2 mb-7">
              <Card className="p-3 text-center text-white !bg-[#1B4242]">
                <div className="mb-3">
                  <h6>{user.fullName || user.firstName + " " + user.lastName}</h6>
                  <p className="m-0">{user.email}</p>
                </div>
                <div className="mt-8">
                  <p className="m-0">
                    <span className="font-bold">Role:</span> users
                  </p>
                  <p className="m-0">
                    <span className="font-bold">Joined:</span>{" "}
                    {new Date(user.createdAt).toDateString()}
                  </p>
                </div>
                {plan.length > 0 && (
                  <div className="mt-8">
                    <p className="m-0">
                      <span className="font-bold">Plan:</span> {plan}
                    </p>
                  </div>
                )}
              </Card>
            </div>
            <div className="mx-2"></div>
            <div className="w-full">
              <Card className="p-3 !bg-[#1B4242] !text-white">
                <ProfileTabs />
              </Card>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Profile;
